import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	centerTextLabel: {
		id: 'issue-field-statistics.donut-chart-container.donut-chart.center-text-label',
		defaultMessage: 'Total',
		description:
			'Text explaining the number represents the total number of items counted for the displayed statistic',
	},
});
